exports.rootAPI = process.env.VUE_APP_ROOT_API
exports.sidebarVisiblity = process.env.VUE_APP_SHOW_SIDEBAR
